"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.braintreeOnShippingContactSelectedApple = void 0;
const manageBraintreeState_1 = require("../manageBraintreeState");
const src_1 = require("../..");
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
function braintreeOnShippingContactSelectedApple(event) {
    return __awaiter(this, void 0, void 0, function* () {
        const { iso_code: currencyCode } = (0, checkout_frontend_library_1.getCurrency)();
        const applePaySession = (0, manageBraintreeState_1.getBraintreeApplePaySessionChecked)();
        const shippingAddress = event.shippingContact;
        const address = (0, src_1.formatBraintreeShippingAddressApple)(shippingAddress);
        const fail = () => {
            const { order_total } = (0, checkout_frontend_library_1.getApplicationState)();
            applePaySession.completeShippingContactSelection({
                errors: [new ApplePayError('shippingContactInvalid')],
                newTotal: { label: 'Total', amount: (0, src_1.getValueByCurrency)(order_total, currencyCode) },
            });
        };
        const response = yield (0, src_1.callShippingAddressEndpoint)(address, true);
        if (response.success) {
            const shippingLinesResponse = yield (0, checkout_frontend_library_1.getShippingLines)(src_1.API_RETRY);
            const taxResponse = yield (0, checkout_frontend_library_1.setTaxes)(src_1.API_RETRY);
            if (shippingLinesResponse.success && taxResponse.success) {
                const { order_total } = (0, checkout_frontend_library_1.getApplicationState)();
                const displayItems = (0, src_1.getPaymentRequestDisplayItems)().map(({ label, amount }) => ({
                    label,
                    amount: (0, src_1.getValueByCurrency)(amount, currencyCode),
                }));
                const { available_shipping_lines: shippingLines } = (0, checkout_frontend_library_1.getShipping)();
                const shippingOptions = shippingLines.map(p => ({
                    label: p.description,
                    detail: '',
                    amount: (0, src_1.getValueByCurrency)(p.amount, currencyCode),
                    identifier: p.id
                }));
                applePaySession.completeShippingContactSelection({
                    newLineItems: displayItems,
                    newShippingMethods: shippingOptions,
                    newTotal: { label: 'Total', amount: (0, src_1.getValueByCurrency)(order_total, currencyCode) },
                });
            }
            else {
                fail();
            }
        }
        else {
            fail();
        }
    });
}
exports.braintreeOnShippingContactSelectedApple = braintreeOnShippingContactSelectedApple;
